import { Accordion } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';

import styles from './Help.module.css';
import HelpContents from './HelpContents';

type TProps = {
  className?: string;
  loading?: boolean;
  expanded?: boolean;
};

const Help = ({ className, loading, expanded }: TProps) => {
  const { t } = useLingui();

  if (expanded) {
    return (
      <div className={styles.expandedContainer}>
        <h3>
          <Trans>Still need help?</Trans>
        </h3>
        <HelpContents />
      </div>
    );
  }

  return (
    <Accordion
      className={clsx(styles.helpContainer, className, {
        [styles.loading]: loading,
      })}
      titleClassName={styles.title}
      title={t`Still need help?`}
      frame={false}
      small
    >
      <HelpContents />
    </Accordion>
  );
};

export default Help;
